const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://smartcity-api.cgis.asia/",
        media_url: "https://smartcity-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "smartcity",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/smartcity/wms/",
  },
  production: {
      api: "https://smartcity-api.cgis.asia/",
      media_url: "https://smartcity-api.cgis.asia/",
      domainAdminSide: "https://admin.smartcity.cgis.asia",
      domainUserSide: "https://smartcity.cgis.asia",
      domainName: "smartcity.cgis.asia",
      workSpace: "smartcity",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/smartcity/wms/",
  },
};

module.exports = apiEnvironment[env];
